import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden"]

  connect() {
    this.inputTargets.forEach((input, index) => {
      input.addEventListener("input", (e) => this.handleInput(e, index))
      input.addEventListener("keydown", (e) => this.handleKeydown(e, index))
      input.addEventListener("paste", (e) => this.handlePaste(e))
    })
  }

  handleInput(event, index) {
    const input = event.target
    const value = input.value

    // Only allow digits
    input.value = value.replace(/[^0-9]/g, "")

    if (input.value.length === 1 && index < this.inputTargets.length - 1) {
      this.inputTargets[index + 1].focus()
    }

    this.updateHiddenField()
  }

  handleKeydown(event, index) {
    const input = event.target

    if (event.key === "Backspace" && input.value === "" && index > 0) {
      this.inputTargets[index - 1].focus()
    }

    // Handle arrow keys
    if (event.key === "ArrowLeft" && index > 0) {
      event.preventDefault()
      this.inputTargets[index - 1].focus()
    }

    if (event.key === "ArrowRight" && index < this.inputTargets.length - 1) {
      event.preventDefault()
      this.inputTargets[index + 1].focus()
    }
  }

  handlePaste(event) {
    event.preventDefault()
    const pastedData = (event.clipboardData || window.clipboardData).getData("text")
    const digits = pastedData.replace(/[^0-9]/g, "").slice(0, 6)

    digits.split("").forEach((digit, index) => {
      if (this.inputTargets[index]) {
        this.inputTargets[index].value = digit
      }
    })

    // Focus the next empty input or the last one
    const nextEmptyIndex = digits.length < 6 ? digits.length : 5
    this.inputTargets[nextEmptyIndex].focus()

    this.updateHiddenField()
  }

  updateHiddenField() {
    const code = this.inputTargets.map(input => input.value).join("")
    this.hiddenTarget.value = code
  }
}
